export function FlagIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5" y="1" width="1" height="19" rx="0.5" fill="#1EADA1" />
      <path d="M18 7L7.5 12.1962L7.5 1.80385L18 7Z" fill="#FF5B5B" />
    </svg>
  )
}
